export class FormatProdutosCadastro {
  produtoId = null;
  informacao = null;
  codigoProduto = null;
  codigoBarra = null;
  gtin = null;
  grupoProdutoId = null;
  tipo = null;
  descricao = null;
  produtoInformacaoId = null;
  unidadeComercialCompraId = null;
  unidadeComercialVendaId = null;
  conversorEntrada = null;
  estoqueAtual = null;
  fracionavel = null;
  lerPesoPorBalanca = null;
  precoCompra = null;
  precoCusto = null;
  precoMedio = null;
  lucroDesejado = null;
  comissao = null;
  precoVenda = null;
  grupoTributacaoId = null;
  tipoItemId = null;
  ncmCodigo = null;
  ncmId = null;
  cestId = null;
  origemMercadoriaId = null;
  informacaoAdicionalNfe = null;
  informacaoComplementar = null;
  modeloGradeId = null;
  fornecedores = null;
  estoqueMinimo = null;
  altura = null;
  largura = null;
  peso = null;
  comprimento = null;
  isMedicamento = null;
  dataValidade = null;
  dataFabricacao = null;
  precoMaxConsumo = null;
  numLote = null;
  qtdLote = null;
  agregado = null;
  prodAnvisa = null;
  motivoIsencao = null;
  embalagem = null;
  isCombustivel = null;
  anpCodigo = null;
  anpDescricao = null;
  unidadeTributavelId = null;
  qtdTributavel = null;
  glp = null;
  gasNaturalNacional = null;
  gasNaturalImp = null;
  valorPartida = null;
  codif = null;
  qtdCombTempAmbiente = null;
  bcCide = null;
  aliquotaCide = null;
  valorCide = null;
  indicadorImportacao = null;
  ufOrigem = null;
  percentualUf = null;

  constructor(item) {
    this.produtoId = item.produtoId ? item.produtoId : null;
    this.informacao = item.informacao;
    this.codigoProduto = item.codigoProduto;
    this.codigoBarra = item.codigoBarra;
    this.gtin = item.gtin;
    this.grupoProdutoId = item.grupoProdutoId;
    this.tipo = item.tipo;
    this.descricao = item.descricao;
    this.produtoInformacaoId = item.produtoInformacaoId;
    this.unidadeComercialCompraId = item.unidadeComercialCompraId;
    this.unidadeComercialVendaId = item.unidadeComercialVendaId;
    this.conversorEntrada = item.conversorEntrada;
    this.estoqueAtual = item.estoqueAtual;
    this.fracionavel = item.fracionavel;
    this.lerPesoPorBalanca = item.lerPesoPorBalanca;
    this.precoCompra = item.precoCompra;
    this.precoCusto = item.precoCusto;
    this.precoMedio = item.precoMedio;
    this.lucroDesejado = item.lucroDesejado;
    this.comissao = item.comissao;
    this.precoVenda = item.precoVenda;
    this.grupoTributacaoId = item.grupoTributacaoId;
    this.tipoItemId = item.tipoItemId;
    this.ncmCodigo = item.ncmCodigo;
    this.ncmId = item.ncmId;
    this.cestId = item.cestId;
    this.origemMercadoriaId = item.origemMercadoriaId;
    this.informacaoAdicionalNfe = item.informacaoAdicionalNfe;
    this.informacaoComplementar = item.informacaoComplementar;
    this.modeloGradeId = item.modeloGradeId;
    this.fornecedores = item.fornecedores;
    this.estoqueMinimo = item.estoqueMinimo;
    this.altura = item.altura;
    this.largura = item.largura;
    this.peso = item.peso;
    this.comprimento = item.comprimento;
    this.isMedicamento = item.isMedicamento;
    this.dataValidade = item.dataValidade;
    this.dataFabricacao = item.dataFabricacao;
    this.precoMaxConsumo = item.precoMaxConsumo;
    this.numLote = item.numLote;
    this.qtdLote = item.qtdLote;
    this.agregado = item.agregado;
    this.prodAnvisa = item.prodAnvisa;
    this.motivoIsencao = item.motivoIsencao;
    this.embalagem = item.embalagem;
    this.isCombustivel = item.isCombustivel;
    this.anpCodigo = item.anpCodigo;
    this.anpDescricao = item.anpDescricao;
    this.unidadeTributavelId = item.unidadeTributavelId;
    this.qtdTributavel = item.qtdTributavel;
    this.glp = item.glp;
    this.gasNaturalNacional = item.gasNaturalNacional;
    this.gasNaturalImp = item.gasNaturalImp;
    this.valorPartida = item.valorPartida;
    this.codif = item.codif;
    this.qtdCombTempAmbiente = item.qtdCombTempAmbiente;
    this.bcCide = item.bcCide;
    this.aliquotaCide = item.aliquotaCide;
    this.valorCide = item.valorCide;
    this.indicadorImportacao = item.indicadorImportacao;
    this.ufOrigem = item.ufOrigem;
    this.percentualUf = item.percentualUf;
  }
}
